export class DefinedFeatureFlags {
  static LogYard = 'LogYard';
  static Coil: string = 'Coil';
  static TrackIndividualLogs: string = 'TrackIndividualLogs';
  static MoveTimberFromLogSorterBins = 'MoveTimberFromLogSorterBins';
  static Bulk: string = 'Bulk';
  static Packages: string = 'Packages';
  static PackageStorage: string = 'PackageStorage';
  static ProductionLine: string = 'ProductionLine';
  static SimulationOptions: string = 'SimulationOptions';
  static DeliveryTransaction: string = 'DeliveryTransaction';
}
